import { render, staticRenderFns } from "./EmployeeCardTag.vue?vue&type=template&id=165a18eb"
import script from "./EmployeeCardTag.vue?vue&type=script&lang=ts"
export * from "./EmployeeCardTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165a18eb')) {
      api.createRecord('165a18eb', component.options)
    } else {
      api.reload('165a18eb', component.options)
    }
    module.hot.accept("./EmployeeCardTag.vue?vue&type=template&id=165a18eb", function () {
      api.rerender('165a18eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeCardTag.vue"
export default component.exports